import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import store from './store';
import Login from './Pages/Auth/Login/Container';
import ResetPassword from './Pages/Auth/ResetPassword/Container';
import CheckZip from './Pages/CheckZip/Container';
import ServiceType from './Pages/ServiceType';
import Subscription from './Pages/Subscription/Container';
import WizardMain from './Pages/Residential/Container';
import DogInfo from './Pages/DogInfo';
import Registration from './Pages/Registration';
import UserAccount from './Pages/UserAccount/Container';
import Commercial from './Pages/commercial/Container';
import Pay from './Pages/Pay/Container';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={CheckZip} />
          <Route exact path='checkzip/:id/:scorpion_id' component={CheckZip} />
          <Route path='/login' component={Login} />
          <Route path='/services' component={ServiceType} />
          <Route path='/subscription' component={Subscription} />
          <Route path='/getquote' component={WizardMain} />
          <Route path='/doginfo' component={DogInfo} />
          <Route path='/registration' component={Registration} />
          <Route path='/account' component={UserAccount} />
          <Route path='/commercial' component={Commercial} />
          <Route path='/reset-password/:token' component={ResetPassword} />
          <Route path='/pay' component={Pay} />
          <Route exact path='**' component={CheckZip} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
